export const rewardsSection = "/rewards/";

export const rewardsSettingsPath = rewardsSection;

export const rewardsSettingsUrl = () => rewardsSettingsPath;
